module.exports = __webpack_public_path__ + "static/media/honeybee.94159009.webp";